import { render, staticRenderFns } from "./MUS002-EditarInformacion.vue?vue&type=template&id=23f39470&"
import script from "./MUS002-EditarInformacion.vue?vue&type=script&lang=js&"
export * from "./MUS002-EditarInformacion.vue?vue&type=script&lang=js&"
import style0 from "./MUS002-EditarInformacion.vue?vue&type=style&index=0&id=23f39470&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports